<template>
    <div class="page bg-gray page-flex">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <div class="center-box flex click" @click="$refs.houseQuarterList.popupShow = true">
                {{orgName || '全部小区'}}
                <div class="alifont icon-lujingbeifen"></div>
            </div>
            <div class="right"></div>
        </div>
        <div class="flex1 posi-rel pd-025 pb-25">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div class="card pd-25 mt-20 mg" v-for="(item,$index) in data" :key="$index">
                    <div class="flex-between flex-center fs-32 pb-15">
                        <div>
                            <div class="color-333 font-bold">{{item.shopName}}</div>
                            <div class="color-999 fs-28 mt-5">{{item.address}}</div>
                        </div>
                        <div class="color-main font-bold" v-if="item.spaceNum != 0">{{item.spaceNum}}空</div>
                        <div class="color-warning font-bold" v-if="item.spaceNum == 0">已满</div>
                    </div>
                    <div class="list">
                        <div class="cargo-item" :class="way.status == 0 ?'empty':'has click'" v-for="(way,$wayIndex) in item.zoneWayList" :key="$wayIndex" >
                            <div class="fs-28 text-center" :class="way.status == 0 ?'color-main':'color-org'">货道{{way.wayCode}}-{{way.status == 0?'空':'已存'}}</div>
                            <div class="cargo-btn" v-if="way.status == 1" @click="toDetail(way)">查看</div>
                            <div class="cargo-btn" v-if="way.status == 1" @click="clearDetail(way)">清空</div>
                        </div>
                    </div>
                </div>
            </scroller>

        </div>
        <houseQuarterList ref="houseQuarterList" @sure="quarterConfirm"></houseQuarterList>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    import houseQuarterList from "./houseQuarterList";
    import {  clearZoneWay } from "@/api/shop";

    export default {
        name: "lockerHouseDetail",
        mixins: [initData, routerBack, getAppStatusHeight],
        components: {appStatus,houseQuarterList},
        data(){
            return{
                orgId: null,
                orgName:''
            }
        },
        created() {
            this.orgId = this.$route.query.orgId;
            this.orgName = this.$route.query.orgName;
        },
        methods:{
            back(){
                if(this.isBackClose){
                    try{
                        window.native.onFinish();
                    }catch (e) {

                    }
                }else{
                    try{
                        window.native.onBack();
                    }catch (e) {
                        this.$router.go(-1)
                    }
                }
            },

            beforeInit() {
                this.params = { page : this.page, limit: this.limit,orgId:this.orgId};
                this.url = 'shop/shopZoneWay/qryOrgWayUseDetail';
                return true
            },

            toDetail(data){
                if(data.status == '0'){
                    return
                }else{
                    this.getScrollerPosition();
                    this.$router.push({name:'lockerOrderDetail',query:{wayId:data.wayId}})
                }
            },
            clearDetail(data){
                let _this = this;
                this.$dialog
                    .alert({
                        title: '提示',
                        message: '确认清除寄存关联的订单?',
                        showCancelButton: true
                    })
                    .then(() => {
                        clearZoneWay({wayId:data.wayId}).then((res) => {
                            if (res.code == 0) {
                                this.$toast("操作成功");
                                _this.init();
                            }
                        })
                    })
                    .catch((e) => {
                        console.info(e)
                        //点击取消按钮后的调用
                        console.log('cancel')
                    })


            },

            quarterConfirm(data){
                this.orgId = data.orgId;
                this.orgName = data.orgName;
                this.handleQuery()
            },
        },
        beforeRouteEnter(to, from, next) {
            if (from.name == "lockerOrderDetail") {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack) {
                if(this.hasAlive){
                    this.handleQuery();
                }
            }
            this.$route.meta.isBack = false;
        },
    }
</script>

<style scoped lang="scss">
    .icon-xpsousuo{
        font-size: .48rem;
    }
    .icon-lujingbeifen{
        font-size: .22rem;
        color: #999;
    }
    .list{
        display: flex;
        flex-wrap: wrap;
        .cargo-item{
            width: 2.1rem;
            height: 2.3rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-radius: .12rem;
            margin-right: .1rem;
            margin-top: .1rem;
            font-weight: bold;
            &:nth-child(3n){
                margin-right: 0;
            }
            &.empty{
                border: 1px solid rgba(131,194,33,0.2);
            }
            &.has{
                background:rgba(255,244,236,1);
                border:.01rem solid rgba(255,133,0,0.2);
            }
            .cargo-btn{
                width: 1.44rem;
                height: .52rem;
                text-align: center;
                line-height: .52rem;
                border-radius: .08rem;
                margin: .15rem auto 0;
                background: #FF8500;
                color: #fff;
                font-size: .24rem;
            }
        }
    }
    .mg{
        margin: .2rem .25rem;
    }
</style>



// WEBPACK FOOTER //
// lockerHouseDetail.vue?7aba5086